var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunrise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefIcon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.69 13.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    className: "cls-1",
    d: "M17.25 11.85a6 6 0 01-.25 1.63c-1.65-.1-3.37-.15-5.15-.15s-3.51.05-5.16.15a5.33 5.33 0 01-.25-1.63 5.41 5.41 0 1110.81 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    className: "cls-1",
    d: "M11.84 4.3a.5.5 0 01-.5-.5V.5a.5.5 0 01.5-.5.5.5 0 01.5.5v3.3a.5.5 0 01-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    className: "cls-1",
    d: "M17.53 6.66a.5.5 0 01-.5-.5.49.49 0 01.15-.36l2.33-2.33a.5.5 0 01.71 0 .52.52 0 010 .7l-2.34 2.34a.51.51 0 01-.35.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    className: "cls-1",
    d: "M23.19 12.34h-3.3a.5.5 0 01-.5-.5.5.5 0 01.5-.5h3.3a.51.51 0 01.5.5.5.5 0 01-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    className: "cls-1",
    d: "M3.8 12.34H.5a.5.5 0 01-.5-.5.5.5 0 01.5-.5h3.3a.5.5 0 01.5.5.5.5 0 01-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    className: "cls-1",
    d: "M6.16 6.66a.53.53 0 01-.36-.15L3.47 4.18a.5.5 0 01.71-.71L6.51 5.8a.51.51 0 01-.35.86z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise);
export default __webpack_public_path__ + "static/media/sunrise.ee64597bab08bc3d4aad09ae93735498.svg";
export { ForwardRef as ReactComponent };